import { render, staticRenderFns } from "./DeliveryReOrder.vue?vue&type=template&id=e6a7f67e&scoped=true&"
import script from "./DeliveryReOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveryReOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReOrder.vue?vue&type=style&index=0&id=e6a7f67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a7f67e",
  null
  
)

export default component.exports